import './TravelBlock.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {connect} from "react-redux";
import {ArrIcon, BlogBlockArrIcon} from "../../../assets/images";
import BlogCard from "../../uiElements/cards/blogCard/BlogCard";
import {Link} from "react-router-dom";

function TravelBlock(props) {
    const {travel,staticTexts} = props

    return <div className={'travelBlock-wrapper'}>
        {
            travel?.length ? <Link to={'/travel'} className={'travelBlock-header'}>
                <div className={'travelBlock-title'}>
                    {staticTexts?.homepage_travel_title}
                </div>
                <div className={'travelBlock-more'}>
                    <BlogBlockArrIcon/>
                </div>
            </Link> : ''
        }
        <div className={'travelBlock'}>
            {
                travel?.map(item => {
                    return <div className={'travelBlock-card'}>
                        <BlogCard item={item}/>
                    </div>
                })
            }
        </div>
    </div>

}const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'travel',
    ])
};
const mapDispatchToProps = {
};
export default connect(mapStateToProps,mapDispatchToProps)(TravelBlock);